import { Navigate, Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { InboxesAccessLayout } from 'pages/settings/pages/inboxes/layout/InboxesAccessLayout'
import { InboxesPageLayout } from 'pages/settings/pages/inboxes/layout/InboxesPageLayout'
import { InboxPageAccessLayout } from 'pages/settings/pages/inboxes/layout/InboxPageAccessLayout'
import { SettingsRoutes } from 'pages/settings/route/type'
import { InboxPageCallingV1Redirect } from 'pages/settings/pages/inboxes/layout/InboxPageCallingV1Redirect'
import { InboxPageV1Redirect } from 'pages/settings/pages/inboxes/layout/InboxPageV1Redirect'
import { InboxesRoutes } from './type'

export const InboxesRouterV1 = observer(() => {
  return (
    <Routes>
      <Route element={<InboxesAccessLayout />}>
        <Route element={<InboxesPageLayout />}>
          <Route
            index
            element={<Navigate to={`/${SettingsRoutes.root}/${InboxesRoutes.root}`} />}
          />
          <Route path={'all-inboxes'}>
            <Route
              index
              element={<Navigate to={`/${SettingsRoutes.root}/${InboxesRoutes.root}`} />}
            />
            <Route element={<InboxPageAccessLayout />}>
              <Route
                path={'new'}
                element={
                  <Navigate
                    to={`/${SettingsRoutes.root}/${InboxesRoutes.root}/${InboxesRoutes.new}`}
                  />
                }
              />
              <Route path={':id'}>
                <Route element={<InboxPageV1Redirect />}>
                  <Route path={InboxesRoutes.members} element={<div>members</div>} />
                  <Route path={InboxesRoutes.teams} element={<div>teams</div>} />
                  <Route path={InboxesRoutes.numbers} element={<div>numbers</div>} />
                  <Route path={InboxesRoutes.settings} element={<div>settings</div>} />
                </Route>

                <Route element={<InboxPageCallingV1Redirect />}>
                  <Route path={InboxesRoutes.calling} element={<div>calling</div>} />
                </Route>

                <Route index element={<Navigate to={InboxesRoutes.members} />} />
              </Route>
            </Route>
          </Route>
          <Route
            path={'group-inboxes'}
            element={<Navigate to={`/${SettingsRoutes.root}/${InboxesRoutes.root}`} />}
          />

          <Route path={'*'} element={<Navigate to={InboxesRoutes.root} />} />
        </Route>
      </Route>
    </Routes>
  )
})
